import store from '@/store'
import {auth_route} from "@/config/auth";

export default (to, from, next) => {
    if (store.getters['auth/check']) {
        next({ name: auth_route })
    } else {
        next()
    }
}